const STORAGE_KEY = 'xra_utm';

const REFERRER_MAP = [
  { pattern: 'google', source: 'google', medium: 'organic' },
  { pattern: 'bing', source: 'bing', medium: 'organic' },
  { pattern: 'facebook', source: 'facebook', medium: 'social' },
  { pattern: 'instagram', source: 'instagram', medium: 'social' },
  { pattern: 'twitter', source: 'twitter', medium: 'social' },
  { pattern: 't.co', source: 'twitter', medium: 'social' },
  { pattern: 'linkedin', source: 'linkedin', medium: 'social' },
  { pattern: 'yahoo', source: 'yahoo', medium: 'organic' },
];

function inferFromReferrer() {
  const referrer = document.referrer;
  if (!referrer) return null;
  const match = REFERRER_MAP.find((r) => referrer.includes(r.pattern));
  if (!match) return null;
  return { utm_source: match.source, utm_medium: match.medium };
}

export function captureUtmParams() {
  const params = new URLSearchParams(window.location.search);
  const hasUtm =
    params.has('utm_source') ||
    params.has('utm_medium') ||
    params.has('utm_campaign') ||
    params.has('utm_content');

  if (!hasUtm) {
    if (!sessionStorage.getItem(STORAGE_KEY)) {
      const inferred = inferFromReferrer();
      if (inferred) {
        sessionStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            utm_source: inferred.utm_source,
            utm_medium: inferred.utm_medium,
            utm_campaign: '',
            utm_content: '',
          })
        );
      }
    }
    return;
  }

  const existing = getStoredUtm();
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({
      utm_source: params.get('utm_source') || (existing && existing.utm_source) || '',
      utm_medium: params.get('utm_medium') || (existing && existing.utm_medium) || '',
      utm_campaign: params.get('utm_campaign') || (existing && existing.utm_campaign) || '',
      // captured once at entry, never overwritten — it's the origin signal
      utm_content: (existing && existing.utm_content) || params.get('utm_content') || '',
    })
  );
}

export function getStoredUtm() {
  const raw = sessionStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

export function chainUtmMedium(context) {
  const utm = getStoredUtm();
  if (!utm) return;
  const base = utm.utm_medium || '';
  const segments = base ? base.split('-') : [];
  // checkAuth can re-fire on repeat navigations (uid persists in the URL),
  // so guard against re-appending a context that's already in the chain
  if (segments.indexOf(context) !== -1) return;
  utm.utm_medium = base ? `${base}-${context}` : context;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(utm));
}
